import es from './es.json';
import en from './en.json';
import ge from './ge.json';

export type Language = 'es' | 'en' | 'ge';
type Translations = typeof es;

const translationsMap: Record<Language, Translations> = { es, en, ge };

const translations = {
  es,
  en,
  ge,
  get: (language: Language, key: string): string => {
    // keys válidas:
    // 'welcome'
    // 'home/background_tag'
    const keys = key.split('/');
    let result: any = translationsMap[language];

    for (const part of keys) {
      result = result?.[part];
      if (result === undefined) {
        return `Missing translation: ${key}`;
      }
    }

    return typeof result === 'string' ? result : `Invalid translation type: ${key}`;
  },
};

export default translations;
